/**
 * COMPONENT: GameCanvas
 * Canvas di rendering ottimizzato per il gioco
 */

import React, { useRef, useEffect, forwardRef, useImperativeHandle } from 'react'

interface GameCanvasProps {
  width: number
  height: number
  className?: string
  onClick?: () => void
}

export interface GameCanvasRef {
  getContext: () => CanvasRenderingContext2D | null
  clear: () => void
}

export const GameCanvas = forwardRef<GameCanvasRef, GameCanvasProps>(
  ({ width, height, className = '', onClick }, ref) => {
    const canvasRef = useRef<HTMLCanvasElement>(null)

    useImperativeHandle(ref, () => ({
      getContext: () => {
        const canvas = canvasRef.current
        return canvas ? canvas.getContext('2d') : null
      },
      clear: () => {
        const canvas = canvasRef.current
        const ctx = canvas?.getContext('2d')
        if (ctx) {
          ctx.fillStyle = '#000'
          ctx.fillRect(0, 0, width, height)
        }
      }
    }))

    useEffect(() => {
      const canvas = canvasRef.current
      if (canvas) {
        canvas.width = width
        canvas.height = height
      }
    }, [width, height])

    return (
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        className={`border-4 border-yellow-400 rounded-lg bg-black ${className}`}
        style={{ 
          imageRendering: 'pixelated',
          cursor: 'default'
        }}
        onClick={onClick}
      />
    )
  }
)

GameCanvas.displayName = 'GameCanvas'
